import type { LocalizedSelectOption, SelectOption } from '@/types/ui'

export type EnumLabelLanguage = 'th' | 'en'

export function getEnumOptionLabel(option: SelectOption | undefined, language: EnumLabelLanguage): string | undefined {
  if (!option) return undefined

  return language === 'th' ? option.labelTh : option.labelEn
}

export function getEnumLabel(
  options: Array<SelectOption | LocalizedSelectOption> | undefined,
  value: string | null | undefined,
  language: EnumLabelLanguage,
  fallback = '-',
): string {
  if (!value) return fallback

  const option = options?.find(option => option.value === value)
  if (option && 'label' in option) return option.label

  return getEnumOptionLabel(option, language) ?? value
}
